// components/Testimonials.js
import React, { useEffect } from 'react';
import Slider from 'react-slick';
import { FaStar } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Styles/Testimonials.css';

const testimonials = [
  {
    name: 'John Doe',
    company: 'Google',
    feedback: 'Iqube Technologies delivered top-notch solutions with fast turnaround. Highly professional!',
    rating: 5,
  },
  {
    name: 'Jane Smith',
    company: 'AWS',
    feedback: 'Excellent collaboration and quality work. The team is technically sound and responsive.',
    rating: 4,
  },
  {
    name: 'Robert Brown',
    company: 'Microsoft',
    feedback: 'Their cloud automation helped us scale efficiently. Highly recommended for enterprise solutions.',
    rating: 5,
  },
  {
    name: 'Emily White',
    company: 'IBM',
    feedback: 'Great UX/UI and frontend delivery. Team works with dedication and agility.',
    rating: 4,
  },
  {
    name: 'David Green',
    company: 'Infosys',
    feedback: 'Robust backend engineering and timely deployment. Iqube is a great tech partner!',
    rating: 5,
  },
];

function Testimonials() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    pauseOnHover: false,
    cssEase: 'ease-in-out',
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="overlay" />
      <div className="slider-container" data-aos="fade-up">
        <Slider {...settings}>
          {testimonials.map((t, index) => (
            <div className="testimonial-slide" key={index}>
              <div
                className="testimonial-content text-center"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <p className="feedback">
                  <i className="fas fa-quote-left"></i> {t.feedback} <i className="fas fa-quote-right"></i>
                </p>
                <h4 className="name">{t.name}</h4>
                <p className="company">{t.company}</p>
                <div className="stars">
                  {[...Array(t.rating)].map((_, i) => (
                    <FaStar key={i} className="text-warning" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Testimonials;
